module.exports = __webpack_public_path__ + "static/media/temperatura_ficus.26630379.svg";